import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import axios from 'axios';



import './InfluencerFeedback.scss';
import MyContext from '../MyContext.jsx';
var customer_XHR={'abort' : ()=>{}};

var singleCustomer_DOM;
const options = [
  { value: 'Select', label: 'Select' },
  { value: 'Good', label: 'Good' },
  { value: 'Average', label: 'Average' },
  { value: 'Bad', label: 'Bad' }

]

class InfluencerFeedback extends Component {
   fileObj = [];
   fileArray = [];
   imagesArray = [];
   url = `${process.env.REACT_APP_SSS}/marketing/influencer`;

    constructor(props) {
      super(props);

      this.influencerSelect = React.createRef();

      this.state = {
        influencers : '',
        influencer : '',
        category_list : [],
        rows: [{
          type : '',
          name : '',
          contact_no : '',
          t :''
        }],
        suggestions : '',
        complaints : '',
        types : '',
        sid :'',
        customer_id : '',
      }
      this.formChange = this.formChange.bind(this);
    }

    componentDidMount(){  
      singleCustomer_DOM = $(".single_customer_details").clone();
      var obj_this = this;
      //get categories and brands
      const url1 = `${process.env.REACT_APP_SSS}/api/get/marketing/feedback/details`;

      $.ajax({
        url : url1,
        data : {
          sid : this.context.user_details.sid
        },
        type : "GET"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          obj_this.setState({
            influencers : return_data.influencers,
            category_list : return_data.categories,
            types : return_data.types
          });
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });

      $(".customer_suggestions_container").on("mousedown",".single_customer_details",function(){
        $(".customer_suggestions_container").empty().css("display","none");
        const customer_id = $(this).attr("customer_id");
        obj_this.context.loading(1);
        const url = `${process.env.REACT_APP_SSS}/api/influencer/details`;
        $.ajax({
          url : url,
          data : {
            sid : obj_this.context.user_details.sid,
            customer_id : customer_id
          },
          type : "POST"
        }).done(function(return_data){
          console.log(return_data);

          obj_this.setState({
            locations : return_data.locations,

          });
          var option = obj_this.state.districts.filter(item => item.value == return_data.influencer.district);
          var option1 = obj_this.state.locations.filter(item => item.value == return_data.influencer.location);
          var option2 = obj_this.state.types.filter(item => item.value == return_data.influencer.influencer_type);

          option = option[0]?option[0]:{};
          option1 = option1[0]?option1[0]:{};
          obj_this.setState({
            selected_brand : return_data.brands,
            influencer_name : return_data.influencer.influencer_name,
            type : option2,
            contact_number : return_data.influencer.contact_no,
            whatsapp_number : return_data.influencer.whatsapp_no,
            dob : return_data.influencer.dob,
            address : return_data.influencer.res_address,
            district : option,
            location : option1,
            job : return_data.influencer.job,
            work_location : return_data.influencer.current_work_location,
            company_name : return_data.influencer.company_name,
            contact_no : return_data.influencer.comp_contact_no,
            contact_person : return_data.influencer.contact_person,
            work_outside :  return_data.influencer.work_outside,
            ouside_locations : return_data.influencer.outside_locations,
            work_type : return_data.influencer.type_of_work,
            experience : return_data.influencer.year_of_experience,
            inf_image : return_data.influencer.image_src,
            customer_id : customer_id,
          });

          for(var i=0;i<return_data.family.length;i++){
            var name = return_data.family[i]['name'];
            var relation = return_data.family[i]['relation'];
            var age = return_data.family[i]['age'];
            var occupation = return_data.family[i]['occupation']
            let totalRemittanceArray = []
            obj_this.state.rows.push({ name, relation,age,occupation })
          }
          obj_this.state.rows.splice(0, 1);

          obj_this.context.loading(0);
        });
      })

      $(".name").on("focusout",function(e){
        console.log(e.target);
        $(".customer_suggestions_container").empty().css("display","none");
      });
      var overflowTimeout = setTimeout(()=>{});

      $(".products_container").on("click",".minimize_button",function(){
        var elem = $(this).parents(".single_product_container");
        elem.find(".qty_unit_price_container").css("display","grid");
        clearTimeout(overflowTimeout);
        var original_height = elem.height();
        elem.height(original_height);
        setTimeout(function(){
        elem.css({
          "height" : "46px",
          "overflow" : "hidden"
          }).find(".maximize_button").css("display","block");
        },1);
        $(this).css("display","none");
      });

      $(".products_container").on("click",".maximize_button",function(){
        var elem = $(this).parents(".single_product_container");
        elem.find(".qty_unit_price_container").css("display","none");
        elem.heightAuto().find(".minimize_button").css("display","block");
        $(this).css("display","none");
        overflowTimeout = setTimeout(function(){
          elem.css("overflow","");
        },1000);
      });
    }

    formChange(e){
      this.setState({
        [e.target.name] : e.target.value
      });
    }

    workChange(e){
      // console.log(option);
      this.setState({
        work_outside : e.target.value
      }); 
    }

    jobChange(e){
      // console.log(option);
      this.setState({
        job : e.target.value
      }); 
    }

    brandChange(option){
      console.log(option);
      this.setState({
        selected_brand : option
      }); 
    }
    onDobChange(value){
      this.setState({dob : value});
    }
  
    districtChange(option){
      this.setState({
        dist : option.value
      });
      this.setState({
        district : option
      });
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/get/locations`;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,

          district_id : option
        },
        type : "GET"
      }).done(function(return_data){
            console.log(return_data);

        if(return_data.status == "success"){
          obj_this.setState({
            locations : return_data.locations,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }

    locationChange(option){
      this.setState({
        loc : option.value
      });
      this.setState({
        location : option
      });
    }

    influencerChange(option){
      this.setState({
        influencer : option
      });
    }

    handleRemoveSpecificRow = (idx) => () => {
      // console.log(idx);
      // return;
      $(".single_product_container").css('background-color','');
      const rows = [...this.state.rows];
      rows.splice(idx, 1);
      this.setState({ 
        rows 
      });
  
    }

    handleChange = idx => e => {
      $(".single_product_container").css('background-color','');
      const { name, value } = e.target;
      const rows = [...this.state.rows];
      const row = {...rows[idx]};
      row[name] = value;
      rows[idx] = row;
      var obj_this = this;
      console.log(rows);
      this.setState({
        rows
      },() =>{
        if(e.target.name == "age" || e.target.name == "occupation" ){
          obj_this.find_total(idx)
        }
      });    
    };

    find_total(idx){
      const rows = [...this.state.rows];
      const row = {...rows[idx]};
      
      // console.log(total);
      rows[idx] = row;
      this.setState({
        rows
      });
    }

    

    handleAddRow = () => {
      $(".single_product_container").css('background-color','');
      // if(!this.validateProducts(this.state.rows)){
      //   return;
      // }
      // console.log(this.state.rows);
      $(".single_product_container:not(:last-of-type) .minimize_button").trigger("click");
      const item = {
        name : "",
        relation: "",
        age : '',
        occupation: "",
      };
      this.setState({
        rows: [...this.state.rows, item]
      });
    };

    validateProducts(items){
      console.log(items);
      if(items.length == 1){
        if(!items[0].type.label){
          alert("Name required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".product").focus();
          return false;
        }
        if(!items[0].name){
          alert("Relation required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".product_qty").focus();
          return false;
        }
        if(!items[0].contact_no){
          alert("Age required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".unit_price").focus();
          return false;
        }
      }else{
        for(var i=0;i<products.length;i++){
          if(products[i].product.label){
            if(!products[i].unit.label){
              alert("Choose unit");
              $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"]").find(".unit").focus();
              return false;
            }
            if(!products[i].qty){
              alert("Quantity required");
              $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"]").find(".product_qty").focus();
              return false;
            }
            if(!products[i].unit_price){
              alert("Unit price required");
              $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"]").find(".unit_price").focus();
              return false;
            }
  
          }
        }
      }
      return true;
    }


     // image onchange hander
     uploadImage = (e) => {
      if (e.target.files && e.target.files[0]) {
        this.setState({
          file: URL.createObjectURL(e.target.files[0])
        });
      }

      this.setState({
          image: e.target.files[0]
      })
      var n = document.getElementsByClassName('inf_img'); 
      var n1 = document.getElementsByClassName('close');  
 
        $(n).css({
            'display': 'inline-block'
        });

        $(n1).css({
          'display': 'inline-block'
      });
      console.log(this.state.file);
  }

  getComponent(e) {
    var name = e.target.getAttribute('name');
    if(name) {
      const url = `${process.env.REACT_APP_SSS}/api/delete/influencer/images`;
      customer_XHR.abort();
      customer_XHR = $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          id : this.state.customer_id
        },
        type : "POST"
        }).done(function(return_data){
          if(return_data.status == "success"){
          }else{
            obj_this.context.loading(0);
          }
        });
        $(e.target).css({
          'display': 'none'
        });
        var n = document.getElementsByClassName('inf_img');  
        $(n).css({
            'display': 'none'
        });
    } 
    else {
      var n = document.getElementsByClassName('inf_img');
      $(e.target).css({
        'display': 'none'
      });
        $(n).css({
            'display': 'none'
        });
        this.setState({
          image: '',
          file : ''
      })
    }

  }


  typeChange(option,idx){
    // console.log(option);
    var obj_this = this;

    $(".single_product_container").css('background-color','');
    const rows = [...this.state.rows];
   
    const row = {...rows[idx]}
    row.type = '';
    row.name = '';
    row.contact_no = '';
  
    rows[idx] = row;
    row.type = option;
    row.t = option.value;
    obj_this.setState({
      rows
    });
  }
    formSubmit(e){
      e.preventDefault();
      const salesorder = this.state;
      
      console.log(salesorder);
     
      
      e.preventDefault();
      var details = this.state;
      if(!details.influencer.value){
        this.influencerSelect.current.focus();
        return;
      }

      var sid =  this.context.user_details.sid;
      console.log(this.fileArray);   
      var obj_this = this;
      var fd = new FormData(document.querySelector('form'));

      for (let i = 0; i < this.state.rows.length; i++) {
        fd.append("type[]", this.state.rows[i]['t']);
        fd.append("name[]", this.state.rows[i]['name']);
        fd.append("contact_no[]", this.state.rows[i]['contact_no']);
      }

      fd.append('sid',sid);

      const url = `${process.env.REACT_APP_SSS}/api/save/marketing/influencer/feedback/details`;

      axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "success"){
          alert("Influencer feedback inserted successfully.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else {
          alert("Network Error.");
          obj_this.context.loading(0);
        }
      });
    }    

  render(){

  return (

    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_feedback_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> INFLUENCER FEEDBACK</div>
          </div> 
          <form className="dealer_form"
            onSubmit={e => this.formSubmit(e)} encType="multipart/form-data" 
          >
            <div className="product_details_container blocks">
            <div className="input_label_head">Influencer Feedback</div>

            <div className="input_label">Influencer *</div>
                  <Select 
                    options={this.state.influencers}  
                    value ={this.state.influencer}
                    name = "influencer"
                    className="district" 
                    ref={this.influencerSelect}
                    onChange={e => this.influencerChange(e)}
                    required
                  />  
              <div className="influencer_feedback block">
				
                <table className="feedback_table">
                  <thead>
                    <tr>
                      <td>Category</td>
                      <td>Rate us</td>
                      <td>Feedback</td>
                    </tr>
                  </thead>
                  <tbody className="categories_container">
                    {this.state.category_list.map((item,idx) => (
                      <tr className="single_category_container" key={idx}>
                        <td className="category_name">{item.category_name}</td>
                        <td>
                          <input className="category_id" type="hidden" name="category[]" value={item.id}/>
                          <Select 
                                    name = "rate[]"
                                    className="rate_us" 
                                    options={options}
                                    required
                          />  
                        </td>
                        <td>
                          <textarea name="feedback[]" className="feedback"></textarea>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>				
              </div>
            </div>
            <div className="products_container blocks">
              <div className="input_label_head" 
                style={{display:"inline-block"}}
              >
                 Contact Sphere
              </div>
              {this.state.rows.map((item, idx) => (
                <div className="single_product_container" key={idx} index={idx}>
                  <div className="product_label_and_delete_button">
                    <div className="maximize_button">
                      <i className="fa fa-plus"></i>
                    </div>
                    <div className="minimize_button">
                      <i className="fa fa-minus"></i>
                    </div>
                    <div className="product_label">
                        {this.state.rows[idx].name}
                    </div>
                    <i className="delete_product_button fa fa-trash-alt" 
                      type="button"
                      style={{visibility:this.state.rows.length >1?"visible":"hidden"}}
                      onClick={this.handleRemoveSpecificRow(idx)}
                    ></i>
                  </div>
                  <div className="qty_unit_price_container">
                    <span
                       style={{visibility:this.state.rows[idx].name.label?"visible":"hidden"}}
                    >Qty : {this.state.rows[idx].contact_no} {this.state.rows[idx].name.label}</span>
                  </div>
                  
                  <div className="input_grid">
                    <div>
                      <div className="input_label">Type</div>
                        <Select 
                            options={this.state.types}  
                            value={this.state.rows[idx].type}
                            name="type"
                            className="company"
                            ref={this.typeSelect}
                            onChange={e => this.typeChange(e,idx)}
                            required
                          />
                      </div>
                      <div>
                        <div className="input_label">Name</div>
                        <input className="input specifications custom_input" 
                          type="text"
                          name="name"
                          value={this.state.rows[idx].name}
                          onChange={this.handleChange(idx)}
                          autoComplete="off"
                        />
                      </div>
                  </div> 
                  
                  <div className="input_grid">
                    <div>
                      <div className="input_label">Contact No</div>
                        <input className="product_qty custom_input"
                          type="number"
                          name="contact_no"
                          pattern="^[0]?[1-9][0-9]{9}$"
                          value={this.state.rows[idx].contact_no}
                          onChange={this.handleChange(idx)}
                          autoComplete="off"
                        />
                      </div>
                  </div>
                </div>
              ))}
              <div className="price_and_add_button_container">
                <button className="add_product_button"
                  type="button"
                  // style={{visibility:this.state.rows[this.state.rows.length-1].nazzzzzzme.label && this.state.rows[this.state.rows.length-1].relation.label?"visible":"hidden"}}
                  onClick={this.handleAddRow}
                >
                  <i className="fa fa-plus"></i> Add
                </button>
              </div>
            </div>

            <div className="product_details_container blocks">
            <div className="customer_container">
              <div className="input_label_head">Other Details</div> 
            </div>
            <div className="input_label">Suggestions *</div>
              <textarea className="input billing_address custom_input" 
                name="suggestions"
                value={this.state.suggestions}
                onChange={this.formChange}
                required
                autoComplete="off"
              />  
            <div className="input_label">Complaints *</div>
              <textarea className="input billing_address custom_input" 
                name="complaints"
                value={this.state.complaints}
                onChange={this.formChange}
                required
                autoComplete="off"
              />  
            </div>
            <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
            </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default InfluencerFeedback;
InfluencerFeedback.contextType = MyContext;
